import { SUPPORTED_FORMATS_BY_LOCALE } from '../../constants/dateConstants';
import { LOCALES, LocaleType } from '../../constants/localeConstants';

/**
 * Retrieves the list of supported date formats for a given locale.
 *
 * Returns an array of objects, each containing:
 * - `regex`: Regular expression pattern for the format.
 * - `label`: Human-readable name for the format (e.g., "MM/DD/YYYY").
 *
 * @param {LocaleType} locale - The locale identifier (`'en-US'`, `'EN_GB'`).
 * @returns {Array<{ regex: RegExp; label: string }>} List of supported date formats.
 */
export const getSupportedFormatsForLocale = (locale: LocaleType): { regex: RegExp; label: string }[] => {
  return SUPPORTED_FORMATS_BY_LOCALE[locale] || SUPPORTED_FORMATS_BY_LOCALE[LOCALES.EN_US];
};
